module.exports = __webpack_public_path__ + "static/media/letalk-logo-white.23343ef8.svg";